module.exports = "https://web-assets.ifttt.com/packs/media/card_brands/mastercard-e0acfc94.svg";